module.exports = __webpack_public_path__ + "media/src/images/icons/arrow_up-83c3c758d1e131c667255211d3ca37c0.svg";